"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/jsx-props-no-spreading */
var react_1 = __importStar(require("react"));
var clsx_1 = __importDefault(require("clsx"));
var react_2 = require("@fluentui/react");
require("./SidePanel.scss");
exports.SidePanel = function (props) {
    var title = props.title, onClose = props.onClose, children = props.children, footer = props.footer, searchBox = props.searchBox;
    var _a = react_1.useState(), show = _a[0], setShow = _a[1];
    react_1.useEffect(function () {
        setTimeout(function () {
            setShow(true);
        }, 10);
    }, []);
    var getAnimationState = function () {
        if (show !== undefined) {
            if (show === true) {
                return 'show';
            }
            return 'hide';
        }
        return '';
    };
    return (react_1.default.createElement("div", { className: clsx_1.default('eta-sidePanel', getAnimationState()) },
        react_1.default.createElement("div", { className: 'header' },
            react_1.default.createElement(react_2.Label, { className: 'title' }, title),
            react_1.default.createElement(react_2.IconButton, { iconProps: { iconName: 'Cancel' }, onClick: function () {
                    setShow(false);
                    setTimeout(function () {
                        onClose();
                    }, 200);
                } })),
        searchBox && (react_1.default.createElement("div", { className: 'searchBox' },
            react_1.default.createElement(react_2.SearchBox, __assign({}, searchBox)))),
        react_1.default.createElement("div", { className: 'contentView' },
            react_1.default.createElement("div", null, children)),
        footer && (react_1.default.createElement("div", { className: 'footer' }, footer))));
};
//# sourceMappingURL=SidePanel.js.map